import React from "react";
import { NavLink } from "react-router-dom";

const item = ({ item, t }) => (
  <NavLink
    to={item.link}
    exact
    activeClassName="active-menu-item"
    className="list-group-item border-0 text-decoration-none py-3"
    style={{ color: "inherit" }}
  >
    {item.title == "Home"
      ? t("Home")
      : item.title == "Leave"
      ? t("Leave")
      : item.title == "Claims"
      ? t("Claims") 
      : item.title == "Timeclock"
      ? t("Timeclock") 
      : item.title}
  </NavLink>
);

export default item;
